export enum WidgetListItems {
    WATCHLIST = "WLT",
    OVERVIEW = "OVW",
    MARKET_NEWS = "NWS",
    ALERT = "ALR",
    TRADE = "TRD",
    POSITIONS = "POS",
    ORDERS = "ORD",
    NOTIFICATION='NTF',
    HOLDINGS = "HLD",
    AI_ASSISTANT = "AI",
}

/** Widgetbar grid column panels only — notifications use an overlay drawer instead. */
export const isWidgetbarLayoutWidget = (widget: WidgetListItems | null | undefined): widget is WidgetListItems =>
    widget != null && widget !== WidgetListItems.NOTIFICATION